var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBityLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.5,
    cy: 63.5,
    r: 63.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.7593 53.9783C85.4937 54.7041 84.9199 56.2077 85.3186 57.6133C85.8676 59.5489 86.1631 61.5882 86.1631 63.6967C86.1631 74.1467 78.9656 82.9491 69.2674 85.4089C67.8606 85.7661 66.8657 87.0104 66.8657 88.4621V88.4679C66.8657 90.5188 68.8008 92.0281 70.7928 91.5211C83.2314 88.3815 92.4648 77.0962 92.4648 63.6967C92.4648 60.9891 92.084 58.368 91.3777 55.8793C90.812 53.8919 88.5509 52.9413 86.7593 53.9783Z",
    fill: "#0061FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9214 48.5851C45.183 49.3131 46.7611 49.0606 47.7821 48.0214C51.8488 43.8766 57.5065 41.2994 63.7577 41.2994C69.9943 41.2994 75.6397 43.8649 79.7041 47.9921C80.725 49.0312 82.3013 49.2778 83.5606 48.5498H83.5612C85.353 47.5166 85.67 45.0743 84.2199 43.6007C79.0096 38.2935 71.762 35 63.7577 35C55.7353 35 48.4731 38.3111 43.2598 43.6359C41.8138 45.1095 42.132 47.5518 43.9214 48.5851Z",
    fill: "#0061FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5617 88.4484C60.5617 87.0025 59.5721 85.7525 58.1717 85.3954C48.5144 82.9069 41.3576 74.128 41.3576 63.7016C41.3576 61.6105 41.6491 59.5828 42.1905 57.6589C42.5857 56.2533 42.0125 54.7556 40.7476 54.0298C38.9549 52.9929 36.6905 53.9434 36.1283 55.9365C35.4307 58.4077 35.0557 61.0115 35.0557 63.7016C35.0557 77.0658 44.239 88.3217 56.6256 91.5014C58.6193 92.0141 60.5617 90.5049 60.5617 88.4484Z",
    fill: "#0061FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBityLogo);
export default __webpack_public_path__ + "static/media/bityLogo.3e754921d39403e5b383e571cd18e517.svg";
export { ForwardRef as ReactComponent };